import {
  addFooter,
  addHeader,
  section
} from '../../../../../interfaces/JsPDF.extended.interface';

export class ReportText {
  public static SUMMARY: string =
    'This report summarises the estimated financial performance of a radiata pine plantation in Tasmania based on the ' +
    'inputs provided to support high-level decision making. Results are indicative only and should be considered ' +
    'alongside professional advice.';

  public static UNDISCOUNTED_COSTS: string =
    'Total estimated costs over the life of the project, including establishment, maintenance, thinning and harvest ' +
    'activities. Costs are presented in undiscounted terms in the following table (costs are not adjusted based on ' +
    'year the cost is incurred in this summary).';

  public static UNDISCOUNTED_REVENUE: string =
    'Total revenue streams from over the life of the project, including timber products and (where selected) carbon ' +
    'credits. Revenues are presented in undiscounted terms in the following tables (revenues are not adjusted based on ' +
    'the year they earnt in this summary).';

  public static FINANCIAL_ANALYSIS: string =
    'The financial analysis applies the selected discount rate. ' +
    'Net Present Value (NPV) represents the overall value of the project in today’s terms by discounting costs and ' +
    'revenues based on when they occur. Internal Rate of Return (IRR) indicates the annualised rate of return where ' +
    'discounted cost and revenues (cash flow) are equal.';

  public static CASHFLOW_CHART: string =
    'Cumulative cash flow over time with individual year revenue illustrates when ' +
    'the project moves into a positive cash position and how revenue is generated across the project.';

  public static REVENUE_CHART: string =
    'Carbon credit and harvest yields illustrates the timing and unit quantity ' +
    'of revenue streams across the project';

  public static DISCLAIMER: string =
    'Private Forests Tasmania assumes no legal or financial responsibility or liability for assumptions and ' +
    'calculations made to users of the Pine Economic Analysis Tool. Any decisions made by the user based off reports' +
    ' developed from the Pine Economic Analysis Tool remain the sole legal and financial liability of the user.';
}

export const PeatPDFSections: PeatPDFSection[] = [
  {
    heading: 'Undiscounted Costs',
    paragraph: ReportText.UNDISCOUNTED_COSTS,
    dataType: 'table',
    dataKey: 'undiscountedCost'
  },
  {
    heading: 'Undiscounted Revenue',
    paragraph: ReportText.UNDISCOUNTED_REVENUE,
    dataType: 'table',
    dataKey: 'undiscountedRevenue'
  },
  {
    heading: 'Financial Analysis',
    paragraph: ReportText.FINANCIAL_ANALYSIS,
    dataType: 'table',
    dataKey: 'financialAnalysis'
  },
  {
    heading: 'Cashflow Chart',
    paragraph: ReportText.CASHFLOW_CHART,
    dataType: 'image',
    dataKey: 'cashflowChart'
  },
  {
    heading: 'Revenue Chart',
    paragraph: ReportText.REVENUE_CHART,
    dataType: 'image',
    dataKey: 'revenueChart'
  }
];

export function getPeatOverViewSection(
  location: string,
  thinningAge: string,
  harvestAge: number,
  carbonModelled: string
): section {
  let section: section = { title: '', paragraphs: [] };
  section.title = 'Summary';
  section.paragraphs = [
    ReportText.SUMMARY,
    `Location: ${location}`,
    `Thinning Age: ${thinningAge} `,
    `Harvest Age: ${harvestAge}`,
    `Carbon Modelled: ${carbonModelled}`
  ];

  return section;
}

export type PeatPDFSection = {
  heading: string;
  paragraph: string;
  dataKey?: string;
  dataType?: 'table' | 'image';
};

export type PDFTable = {
  head: string[];
  body: any[];
};

export function ensureSpace(
  pdf: any,
  y: number,
  requiredHeight: number,
  margin: number,
  headerHeight: number,
  title
): number {
  const pageHeight = pdf.internal.pageSize.getHeight();

  if (y + requiredHeight > pageHeight - margin) {
    pdf.addPage();
    addHeader(title, pdf, margin, headerHeight);
    addFooter(pdf, margin);

    return headerHeight + margin;
  }

  return y;
}
